/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCampaign = /* GraphQL */ `
  query GetCampaign($id: ID!) {
    getCampaign(id: $id) {
      id
      name
      advertiser
      contract_number
      start_time
      end_time
      deliveryDeadline
      duration
      languages
      notes
      scheduling_notes
      adminNotes
      type
      orderlineID
      sales_segment      
      salesperson
      salesperson_contact
      mediaDeliveryPersonContacts
      sentTo
      status
      automaticStatus
      owner
      ownerName
      collaborators
      viewers
      mediaAgencyID
      mediaAgency {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      mediaCollaborators
      createdAt
      dummyType
      updatedAt
      agency {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      assets {
        nextToken
        __typename
      }
      requiredResolutions {
        nextToken
        __typename
      }
      nativeResolutions {
        nextToken
        __typename
      }
      printSizes {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listCampaigns = /* GraphQL */ `
  query ListCampaigns(
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCampaignsByCreatedAt = /* GraphQL */ `
  query ListCampaignsByCreatedAt(
    $dummyType: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignsByCreatedAt(
      dummyType: $dummyType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
      enabled
      firstName
      lastName
      phoneNumber
      createdAt
      updatedAt
      userGroup
      owner
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        enabled
        firstName
        lastName
        phoneNumber
        createdAt
        updatedAt
        userGroup
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getApprover = /* GraphQL */ `
  query GetApprover($id: ID!) {
    getApprover(id: $id) {
      id
      userID
      name
      email
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listApprovers = /* GraphQL */ `
  query ListApprovers(
    $filter: ModelApproverFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listApprovers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        name
        email
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getApproval = /* GraphQL */ `
  query GetApproval($id: ID!) {
    getApproval(id: $id) {
      id
      approverID
      assetID
      campaignID
      campaignName
      startTime
      endTime
      status
      reason
      deadline
      createdAt
      updatedAt
      owner
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      asset {
        id
        name
        notes
        campaignID
        media
        thumbnail
        thumbnailComplete
        resolution
        metadata
        type
        fileSize
        duration
        dpi
        audio
        dynamicContent
        motiveMarker
        lowResolution
        framerate
        status
        start_time
        end_time
        week_days
        language
        language_confidence_score
        printServiceID
        sentToPrintServiceDate
        senderToPrintService
        startprint_sender
        digitalServiceSender
        digitalServiceDate
        digitalServiceNames
        api_files
        owner
        ownerName
        viewers
        mediaCollaborators
        createdAt
        updatedAt
        individualAssetIdsForMultiPagePDF
        dummyType
        __typename
      }
      __typename
    }
  }
`;
export const listApprovals = /* GraphQL */ `
  query ListApprovals(
    $filter: ModelApprovalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listApprovals(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        approverID
        assetID
        campaignID
        campaignName
        startTime
        endTime
        status
        reason
        deadline
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const approvalsByCampaignID = /* GraphQL */ `
  query ApprovalsByCampaignID(
    $campaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelApprovalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    approvalsByCampaignID(
      campaignID: $campaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        approverID
        assetID
        campaignID
        campaignName
        startTime
        endTime
        status
        reason
        deadline
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAgency = /* GraphQL */ `
  query GetAgency($id: ID!) {
    getAgency(id: $id) {
      id
      phone
      name
      email
      address
      postalNumber
      city
      country
      type
      contacts
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listAgencys = /* GraphQL */ `
  query ListAgencys(
    $filter: ModelAgencyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgencys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAsset = /* GraphQL */ `
  query GetAsset($id: ID!) {
    getAsset(id: $id) {
      id
      name
      notes
      campaignID
      media
      thumbnail
      thumbnailComplete
      resolution
      metadata
      type
      fileSize
      duration
      dpi
      audio
      dynamicContent
      motiveMarker
      lowResolution
      framerate
      status
      start_time
      end_time
      week_days
      language
      language_confidence_score
      printServiceID
      sentToPrintServiceDate
      senderToPrintService
      startprint_sender
      digitalServiceSender
      digitalServiceDate
      digitalServiceNames
      api_files
      owner
      ownerName
      viewers
      mediaCollaborators
      createdAt
      updatedAt
      individualAssetIdsForMultiPagePDF
      dummyType
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      printService {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      __typename
    }
  }
`;
export const listAssets = /* GraphQL */ `
  query ListAssets(
    $filter: ModelAssetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        notes
        campaignID
        media
        thumbnail
        thumbnailComplete
        resolution
        metadata
        type
        fileSize
        duration
        dpi
        audio
        dynamicContent
        motiveMarker
        lowResolution
        framerate
        status
        start_time
        end_time
        week_days
        language
        language_confidence_score
        printServiceID
        sentToPrintServiceDate
        senderToPrintService
        startprint_sender
        digitalServiceSender
        digitalServiceDate
        digitalServiceNames
        api_files
        owner
        ownerName
        viewers
        mediaCollaborators
        createdAt
        updatedAt
        individualAssetIdsForMultiPagePDF
        dummyType
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAssetsByCreatedAt = /* GraphQL */ `
  query ListAssetsByCreatedAt(
    $dummyType: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAssetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssetsByCreatedAt(
      dummyType: $dummyType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        notes
        campaignID
        media
        thumbnail
        thumbnailComplete
        resolution
        metadata
        type
        fileSize
        duration
        dpi
        audio
        dynamicContent
        motiveMarker
        lowResolution
        framerate
        status
        start_time
        end_time
        week_days
        language
        language_confidence_score
        printServiceID
        sentToPrintServiceDate
        senderToPrintService
        startprint_sender
        digitalServiceSender
        digitalServiceDate
        digitalServiceNames
        api_files
        owner
        ownerName
        viewers
        mediaCollaborators
        createdAt
        updatedAt
        individualAssetIdsForMultiPagePDF
        dummyType
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRequiredResolution = /* GraphQL */ `
  query GetRequiredResolution($id: ID!) {
    getRequiredResolution(id: $id) {
      id
      value
      type
      createdAt
      updatedAt
      campaigns {
        nextToken
        __typename
      }
      nativeResolutions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listRequiredResolutions = /* GraphQL */ `
  query ListRequiredResolutions(
    $filter: ModelRequiredResolutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRequiredResolutions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        value
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNativeResolution = /* GraphQL */ `
  query GetNativeResolution($id: ID!) {
    getNativeResolution(id: $id) {
      id
      requiredResolutionID
      value
      type
      active
      verticalCut
      horizontalCut
      createdAt
      updatedAt
      requiredResolution {
        id
        value
        type
        createdAt
        updatedAt
        __typename
      }
      campaigns {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listNativeResolutions = /* GraphQL */ `
  query ListNativeResolutions(
    $filter: ModelNativeResolutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNativeResolutions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        requiredResolutionID
        value
        type
        active
        verticalCut
        horizontalCut
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPrintSize = /* GraphQL */ `
  query GetPrintSize($id: ID!) {
    getPrintSize(id: $id) {
      id
      name
      createdAt
      updatedAt
      campaigns {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listPrintSizes = /* GraphQL */ `
  query ListPrintSizes(
    $filter: ModelPrintSizeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPrintSizes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
